import { render, staticRenderFns } from "./HtmlEditorTiptapToolbarItem.vue?vue&type=template&id=04f56d6c&"
import script from "./HtmlEditorTiptapToolbarItem.vue?vue&type=script&lang=js&"
export * from "./HtmlEditorTiptapToolbarItem.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditorTiptapToolbarItem.vue?vue&type=style&index=0&id=04f56d6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports